import React from 'react'
import { Modal } from 'antd'
import './index.css'
import { useDispatch, useSelector } from 'react-redux'

const ConversationSearchEnabled = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'ConversationSearchEnabled'
  const visible = modalID === visibleModalID

  const createSupportTicket = () => {
    window.open('https://help.cometchat.com/hc/en-us/requests/new', '_blank')
  }
  const openPricingPage = () => {
    window.open('https://www.cometchat.com/pricing', '_blank')
  }

  return (
    <Modal
      className="advanced_search_modal"
      title={false}
      open={visible}
      footer={false}
      maskClosable={false}
      closable={false}
    >
      <div className="conversationSearchModalWrapper">
        <div className="conversationSearchModalContent">
          <div className="conversationSearchModalHeader">
            <div className="conversationSearchIcon" />
          </div>
          <div className="conversationSearchModalBody">
            <div className="conversationSearchModalBodyTitle">
              Conversation and Advanced Search Enabled
            </div>
            <div className="conversationSearchModalBodySubtitle">
              Advanced Search has been successfully enabled. All future messages will be indexed
              automatically. Please note that it may take up to 10 minutes for indexing to begin.
            </div>
          </div>
          <div className="conversationSearchModalNote">
            <ul>
              <li>
                To index historical messages, please create a{' '}
                <span
                  role="button"
                  tabIndex="0"
                  className="conversationSearchModalNoteUnderline"
                  onKeyDown={createSupportTicket}
                  onClick={createSupportTicket}
                >
                  support ticket
                </span>
                .
              </li>
              <li>
                This feature may generate additional usage charges. Refer to the{' '}
                <span
                  role="button"
                  tabIndex="0"
                  className="conversationSearchModalNoteUnderline"
                  onKeyDown={openPricingPage}
                  onClick={openPricingPage}
                >
                  pricing page
                </span>{' '}
                for details.
              </li>
              <li>You can enable/disable this setting anytime.</li>
            </ul>
          </div>
        </div>
        <button type="button" className="redirectButton" onClick={handleCancel}>
          Got it
        </button>
      </div>
    </Modal>
  )
}

export default ConversationSearchEnabled
